import { render } from "./index.vue?vue&type=template&id=615abae7"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/user-invitation-upload-radio/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "615abae7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('615abae7', __exports__)) {
    api.reload('615abae7', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=615abae7", () => {
    api.rerender('615abae7', render)
  })

}


export default __exports__